module.exports = __webpack_public_path__ + "img/help27.12f0d171.png";